import { InputText } from 'primereact/inputtext';
import { useContext, useEffect, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { AdminContext } from '../../contexts/AdminContext';
import { RegNumSearchItem } from './RegNumSearchItem';
import { AuthContext } from '../../contexts/AuthContext';
export const ArchiveSearchApplications = ({ regNums, schoolId }) => {
    const [archiveRegNums, setArchiveRegNums] = useState([...regNums]);
    const [searchText, setSearchText] = useState('');

    const filterTexts = {
        childEgn: 'ЕГН на дете',
        childName: 'име на дете',
        regNumber: 'номер на заявление',
    }

    const [filterOptions, setFilterOptions] = useState({
        childEgn: false,
        childName: false,
        regNumber: true,
        schoolId: schoolId,
    });
    
    useEffect(() => {
        if (filterOptions.regNumber && searchText.length > 0) {
            setArchiveRegNums(state => {
                let newState = regNums.find(x => x.regnumbeR_ID == searchText);
                if (newState) {
                    return [newState];
                } else {
                    return regNums;
                }
            })
        } else if (filterOptions.childEgn && searchText.length > 0) {
            setArchiveRegNums(state => regNums.filter(x => x.egn.includes(searchText)));
        } else if (filterOptions.childName && searchText.length > 0) {
            setArchiveRegNums(state => regNums.filter(x => x.child.chilD_NAME.toLowerCase().includes(searchText.toLowerCase())));
        } else {
            setArchiveRegNums(regNums);
        }
    }, [searchText, filterOptions, regNums])

    const handleCheckboxChange = (option) => {
        setFilterOptions((prevOptions) => ({
            ...prevOptions,
            childEgn: false,
            childName: false,
            regNumber: false,
            [option]: true,
        }));
    };

    const handleChange = (e) => {
        setSearchText(e.target.value)
    };

    const cleanFilterOptions = () => {
        setFilterOptions(state => ({
            childEgn: false,
            childName: false,
            regNumber: true,
            schoolId: schoolId,
            text: '',
        }))
    }
    return (
        <>
            <div className="col-12">
                <div className="overflow-auto card recent-sales p-5 p-4-mob">
                    <div className="form-group mb-2 d-flex flex-column flex-wrap gap-4">
                        <div className="d-flex w-30 justify-content-between align-items-center flex-wrap w-100-mob gap-2">
                            <label className="h6 w-100">Търсене по:</label>
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="regNumber"
                                    onChange={() => handleCheckboxChange('regNumber')}
                                    checked={filterOptions.regNumber}
                                />
                                <label htmlFor="parentEgn" >
                                    Номер на заявление
                                </label>
                            </div>
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="childEgn"
                                    onChange={() => handleCheckboxChange('childEgn')}
                                    checked={filterOptions.childEgn}
                                />
                                <label htmlFor="childEgn">
                                    ЕГН на дете
                                </label>
                            </div>
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="childName"
                                    onChange={() => handleCheckboxChange('childName')}
                                    checked={filterOptions.childName}
                                />
                                <label htmlFor="childName" >
                                    Име на дете
                                </label>
                            </div>
                        </div>
                    </div>

                    <InputText name='text' id="searchText" style={{ width: '60%', marginBottom: '6%' }} value={filterOptions.text} className="w-100-mob" onChange={handleChange} placeholder={`Търсене по ${filterTexts[
                        Object.keys(filterOptions).filter(key => key in filterTexts).find(key => filterOptions[key])
                    ]}`}
                    />

                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-1">
                        {archiveRegNums && archiveRegNums.map(x => <RegNumSearchItem key={x.regnumbeR_ID} regNum={x} action='archive' cleanFilterOptions={cleanFilterOptions} />)}
                    </div>
                </div>
            </div>
        </>
    )
}